import { CONSTS } from '../../config/objectConst'

export async function integrateGTM() {
	if (import.meta.env.PUBLIC_GTM === 'true') {
		const { default: TagManager } = await import('react-gtm-module')

		TagManager.initialize({
			gtmId: CONSTS.GOOGLE_TAG_MANAGER.ID
		})
	}
}
